import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { appRoleSchema, envelopeSchema } from '../lib/schemas';

/**
 * A row in admapp.[role]. Presence in this table is what grants access to the
 * app at all; the `role` column decides whether that access is administrative.
 */
export interface AppRole {
  id: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  user_name: string;
  role: string;
}

export type AppRoleValue = 'admin' | 'user';

export interface AppRoleInput {
  user_name: string;
  role: AppRoleValue;
}

export const appRoleService = {
  async getAll(): Promise<AppRole[]> {
    const result = await apiClient.get(apiUrl.appRoles(), {
      validate: envelopeSchema('app_roles', z.array(appRoleSchema)),
      deduplicate: true,
      context: 'getAppRoles',
    });
    return result.app_roles;
  },

  async create(row: AppRoleInput): Promise<AppRole> {
    const result = await apiClient.post(apiUrl.appRoles(), row, {
      validate: envelopeSchema('app_role', appRoleSchema),
      context: 'createAppRole',
    });
    return result.app_role;
  },

  async update(id: string, row: AppRoleInput): Promise<AppRole> {
    const result = await apiClient.put(apiUrl.appRoles(id), row, {
      validate: envelopeSchema('app_role', appRoleSchema),
      context: 'updateAppRole',
    });
    return result.app_role;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(apiUrl.appRoles(id), {
      context: 'deleteAppRole',
    });
  },
};
